import * as yup from 'yup'

export const emailSchema = yup.string().email('Must be a valid email').required('Email is required')

export const uniqueIdSchema = yup.string().required('Unique ID is required').min(6, 'Must contain 6 or more character')

export const simplePasswordSChema = yup
  .string()
  .required('Password is required')
  .min(8, 'Password must be 8 characters long')

export const passwordSchema = yup
  .string()
  .required('Password is required')
  .min(8, 'Password must be 8 characters long')
  .matches(/[0-9]/, 'Password requires a number')
  .matches(/[a-z]/, 'Password requires a lowercase letter')
  .matches(/[A-Z]/, 'Password requires an uppercase letter')
  .matches(/[^\w]/, 'Password requires a symbol')

export const firstNameSchema = yup.string().required('First name is required')

export const otherNameSchema = yup.string()

export const lastNameShema = yup.string().required('Last name is required')

export const specialtySchema = yup.string().required('Specialty is required')

export const roleSchema = yup.string().required('Select a role')

export const employment_typeSchema = yup.string()

export const genderSchema = yup.string().required('Select your gender')

export const addressSchema = yup.string().required('Address is required')

export const departmentSchema = yup.string().required('Department is required')

export const dobSchema = yup.string()

export const phoneNumberSchema = yup
  .string()
  .matches(/^\+?[\d\s()-]{9,}$/, 'Not a valid phone number')
  .required('Phone number is required')

export const nameSchema = yup.string().required('Location name is required')

export const startTimeSchema = yup.string().required('Start time is required')

export const endTimeSchema = yup.string().required('End time is required')

export const startDateSchema = yup.string().required('Start date is required')

export const endDateSchema = yup.string().required('End date is required')

export const facilitySchema = yup.string().required('Facility is required')
